import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getDataPromise } from 'brock-fetch-utils';
import { AnimatedPageLoader } from 'smartsuite-ui';

export const AdvancedSearchContext = createContext(null);

export default function AdvancedSearchProvider({ apiConstants, children }) {
    const [systemManifest, setSystemManifest] = useState();

    useEffect(() => {
        getDataPromise(apiConstants.getSystemManifestUri()).then(
            (response) => setSystemManifest(response),
            () => setSystemManifest([])
        );
    }, [apiConstants]);

    if (!systemManifest) {
        return <AnimatedPageLoader />;
    }

    return (
        <AdvancedSearchContext.Provider value={{ systemManifest }}>
            {children}
        </AdvancedSearchContext.Provider>
    );
}

export function useAdvancedSearchContext() {
    const context = useContext(AdvancedSearchContext);

    if (!context) {
        throw new Error(
            // eslint-disable-next-line max-len
            'AdvancedSearchContext must be used within a AdvancedSearchProvider. Wrap a parent component in <AdvancedSearchProvider> to fix this error'
        );
    }

    return context;
}

AdvancedSearchProvider.propTypes = {
    apiConstants: PropTypes.instanceOf(Object).isRequired,
    children: PropTypes.node.isRequired,
};
